import styled from 'styled-components';

import logo from '../../assets/images/black-logo-text.png';
import smallLogo from '../../assets/images/black-logo.png';

const Content = styled.div<{ width: number }>`
	background-color: ${p => p.theme.colors.white};
	position: fixed;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	transition: all 0.5s ease-out;
	padding: ${props =>
		props.width < 1300 && props.width > 1024
			? '50px 20px 23px'
			: '50px 40px 23px'};
	left: 0;
	height: 100vh;
	width: ${props =>
		props.width > 1900
			? '320px'
			: props.width <= 1600 && props.width >= 1400
			? '270px'
			: props.width <= 1400 && props.width >= 1200
			? '250px'
			: props.width <= 1200 && props.width >= 1050
			? '220px'
			: '330px'};

	@media (max-width: 1024px) {
		padding-top: 32px;
		width: 163px;
	}
`;

const Block = styled.div`
	width: 100%;
`;

const Center = styled.div`
	display: flex;
	justify-content: center;
`;

const Logo = styled.div`
	height: 55px;
	width: 156px;
	background-image: url(${logo});
	background-repeat: no-repeat;
	background-size: cover;

	@media (max-width: 1024px) {
		background-image: url(${smallLogo});
		height: 54px;
		width: 54px;
	}
`;

const Box = styled.div`
	background-color: ${p => p.theme.colors.yellow};
	width: 237px;
	height: 222px;
	border-radius: 20px;
	padding: 24px 20px;
	display: flex;
	justify-content: space-between;
	flex-direction: column;

	@media (max-width: 1024px) {
		display: none;
	}
`;

const ProfileWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;

	@media (max-width: 1024px) {
		justify-content: center;
	}
`;

const Avatar = styled.div`
	margin-right: 10px;

	@media (max-width: 1024px) {
		margin-right: 0;
	}
`;

const Info = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	@media (max-width: 1024px) {
		display: none;
	}
`;

const Line = styled.div`
	background-color: #ccd2d9;
	width: 100%;
	height: 1px;
	margin-bottom: 31px;
`;

const size = 50;
const Button = styled.button`
	background-color: ${p => p.theme.colors.white};
	border: 1px solid #ccd2d9;
	border-radius: ${size / 2}px;
	height: ${size}px;
	width: ${size}px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Content,
	Block,
	Center,
	Logo,
	Box,
	ProfileWrapper,
	Avatar,
	Info,
	Line,
	Button,
};
